
import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import { Message, MessageBox } from "element-ui";
import store from "@/store";
import {checkPhone} from '@/utils/common'

@Component({
  name: "Login",
})
export default class extends Vue {
  // 倒计时
  codeTime = 0;
  codeloading = false
  loginForm = {
    mobile: '',
    verifycode:''
  }

  getCodeTime () {
    if (this.codeloading) {
      return '获取中'
    }
    return this.codeTime
            ? (this.codeTime < 10 ? '0' : '') + this.codeTime + '秒'
            : '获取验证码'
  }

  /*
   * 获取验证码倒计时
   */
  TimeReduce (): void {
    // 如果倒计时没有完毕 则继续执行
    if (this.codeTime) {
      // 倒计时递减
      this.codeTime--
      // 延迟一秒执行
      setTimeout(() => {
        this.TimeReduce()
      }, 1000)
    }
  }

  checkPhone (phone: string){
    if (!phone) {
      this.$message.warning('请输入手机号')
      return false
    }
    if (phone.length !== 11) {
      this.$message.warning('手机号长度不正确')
      return false
    }
    if (!(/^1[3456789]\d{9}$/.test(phone))) {
      this.$message.warning('手机号格式不正确')
      return false
    }
    return true
  }

  /*
  * 获取手机号验证码
  */
  GetCode (): void {
    // 是否正在获取验证码，由于网络过慢，防重复点击
    if (this.codeloading) {
      return
    }
    // 是否倒计时完毕
    if (this.codeTime) {
      return
    }
    // 验证手机号
    if (!this.checkPhone(this.loginForm.mobile)) {
      return
    }
    api.sendVerifyCode({mobile: this.loginForm.mobile}).then((res) => {
      // 60秒倒计时
      this.codeTime = 60
      // 启用倒计时
      setTimeout(() => {
        this.TimeReduce()
      }, 1000)
    }).finally(() => {
      this.codeloading = false
    })

  }

  private loading = false;

  handleLogin() {
    if (this.loading) {
      return;
    }
    if (!checkPhone(this.loginForm.mobile)) {
      return;
    }
    if (!this.loginForm.verifycode) {
      Message.error("请输入验证码");
      return;
    }
    this.loading = true;

    api
            .getToken({
              mobile: this.loginForm.mobile,
              verifycode: this.loginForm.verifycode,
            })
            .then((data) => {
              // if (data.sys.length === 0) {
              //   this.$alert("暂无权限，请联系管理员分配权限！", "系统提示");
              //   return;
              // }
              store.dispatch("tags/NameView", data.user.username);
              api.getDics().then((res) => {
                store.dispatch("system/addConfig", res);
              });
              store.dispatch("user/Login", data);
              this.$router.push("/home");
            })
            .finally(() => {
              this.loading = false;
            });
  }

}
